import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62bb74a4"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62bb74a4')) {
      api.createRecord('62bb74a4', component.options)
    } else {
      api.reload('62bb74a4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=62bb74a4", function () {
      api.rerender('62bb74a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/automaticSortings/preLoadTruckPickup/index.vue"
export default component.exports